/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { IPlaceCategory, IReverseGeocodeResponse, LatLng } from '../../core/models';
import { GoogleMapsShape } from '../../maps/models';
import { EGeofenceDrawingControlShape, IGeofenceFormData, IPlace } from '../models';

export enum EGeofenceActions {
  SaveGeofence = '[Geofence] Save Geofence',
  SaveGeofenceSuccess = '[Geofence] Save Geofence Success',
  SetGeofenceLatLng = '[Geofence] Set Geofence LatLng',
  GetGeofenceAddress = '[Geofence] Get Geofence Address',
  GetGeofenceAddressSuccess = '[Geofence] Get Geofence Address Success',
  ResetGeofenceState = '[Geofence] Reset Geofence State',
  SetGeofenceDrawingControlShape = '[Geofence] Set Geofence Drawing Control Shape',
  SetGeofenceDrawingControlClearPressed = '[Geofence] Set Geofence Drawing Control Clear Pressed',
  SetSelectedGeofenceShape = '[Geofence] Set Selected Geofence Shape',
  DrawingControlClearPressed = '[Geofence] Drawing Control Clear Pressed',
  GetPlaceDropdownCategories = '[Geofence] Get Place Dropdown Categories',
  GetPlaceDropdownCategoriesSuccess = '[Geofence] Get Place Dropdown Categories Success',
  SetGeofenceCreateOpen = '[Geofence] Set Geofence Create Open',
  ShowExistingGeofenceForEdit = '[Geofence] Show Existing Geofence For Edit'
}

export class SaveGeofence implements Action {
  public readonly type = EGeofenceActions.SaveGeofence;

  constructor(public payload: IGeofenceFormData) {}
}

export class SaveGeofenceSuccess implements Action {
  public readonly type = EGeofenceActions.SaveGeofenceSuccess;

  constructor(public payload?: number) {}
}

export class SetGeofenceLatLng implements Action {
  public readonly type = EGeofenceActions.SetGeofenceLatLng;

  constructor(public payload: LatLng) {}
}

export class GetGeofenceAddress implements Action {
  public readonly type = EGeofenceActions.GetGeofenceAddress;

  constructor(public payload: LatLng) {}
}

export class GetGeofenceAddressSuccess implements Action {
  public readonly type = EGeofenceActions.GetGeofenceAddressSuccess;

  constructor(public payload: IReverseGeocodeResponse) {}
}

export class ResetGeofenceState implements Action {
  public readonly type = EGeofenceActions.ResetGeofenceState;
}

export class SetGeofenceDrawingControlShape implements Action {
  public readonly type = EGeofenceActions.SetGeofenceDrawingControlShape;

  constructor(public payload: EGeofenceDrawingControlShape) {}
}

export class SetGeofenceDrawingControlClearPressed implements Action {
  public readonly type = EGeofenceActions.SetGeofenceDrawingControlClearPressed;

  constructor(public payload: Date) {}
}

export class SetSelectedGeofenceShape implements Action {
  public readonly type = EGeofenceActions.SetSelectedGeofenceShape;

  constructor(public payload: GoogleMapsShape | null) {}
}

export class DrawingControlClearPressed implements Action {
  public readonly type = EGeofenceActions.DrawingControlClearPressed;
}

export class GetPlaceDropdownCategories implements Action {
  public readonly type = EGeofenceActions.GetPlaceDropdownCategories;
}

export class GetPlaceDropdownCategoriesSuccess implements Action {
  public readonly type = EGeofenceActions.GetPlaceDropdownCategoriesSuccess;

  constructor(public payload: IPlaceCategory[]) {}
}

export class SetGeofenceCreateOpen implements Action {
  public readonly type = EGeofenceActions.SetGeofenceCreateOpen;

  constructor(public payload: boolean) {}
}

export class ShowExistingGeofenceForEdit implements Action {
  public readonly type = EGeofenceActions.ShowExistingGeofenceForEdit;

  constructor(public payload: IPlace) {}
}

export type GeofenceActions =
  | SaveGeofence
  | SaveGeofenceSuccess
  | SetGeofenceLatLng
  | GetGeofenceAddress
  | GetGeofenceAddressSuccess
  | ResetGeofenceState
  | SetGeofenceDrawingControlShape
  | SetGeofenceDrawingControlClearPressed
  | SetSelectedGeofenceShape
  | DrawingControlClearPressed
  | GetPlaceDropdownCategories
  | GetPlaceDropdownCategoriesSuccess
  | SetGeofenceCreateOpen
  | ShowExistingGeofenceForEdit;
